import { Component, Inject } from '@angular/core';
import { ManagePermissionsService } from '../services/manage-permissions.service';
import { UserService } from 'src/app/services/user.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {POService} from "../../services/po.service";
import { GuiGuard } from '../../shared/guard/base-gui-guard';
import Swal from 'sweetalert2';
import { Methods } from 'src/app/shared/methods';
import { Router } from '@angular/router';

export interface DialogData {
  userId: number;
}

@Component({
  selector: "app-manage-permissions",
  templateUrl: "./manage-permissions.component.html",
  styleUrls: ["./manage-permissions.component.css"],
})
export class ManagePermissionsComponent {
    public mtds: Methods = new Methods();
  
  isLoading = false;
  disabledPermissionLR = true;
  disabledPermissionBuybacks = true;
  public permissionStatus = false; 
  public permissionStatusColumn = false; 
  disabledVendorStatus = true;

  public permissionInventoryClient = false;
  public disabledPermissionInventoryClient = false;

  
  userDetails;
  permissionsLiveReporting = false;
  permissionsBuybacks = false;
  
  identity;
  token;
  
  constructor(
    private _userService: UserService,
    private _router: Router,

    private _managePermissionsService: ManagePermissionsService,
      public guard: GuiGuard,
    private _poService: POService,
    @Inject(MAT_DIALOG_DATA) public userData: DialogData
  ) {
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    this.getUserDetails(this.token, this.userData.userId);
    this.getStatusVendor(this.token, this.userData.userId);
  }
 
  

    getStatusVendor(token,id): void {
      this.disabledVendorStatus = true;
      this._poService.getVendorStatus(token,id).subscribe(
        r => {
          if (r.status === 'success') {
            // Asegúrate de que r.data[0] contiene el objeto esperado
            const vendorData = r.data[0];  // Asumiendo que la respuesta es un array y estás tomando el primer objeto
            if (vendorData.enableInventory === 1) {
              this.permissionStatus = true;
            } else {
              this.permissionStatus = false;
            }

            if (vendorData.statusColumn === 1) {
              this.permissionStatusColumn = true;
            } else {
              this.permissionStatusColumn = false;
            }

            console.log('respuesta vendor ',vendorData);
          } else {
            console.error('Error en la respuesta del estado del vendedor');
          }
          this.disabledVendorStatus = false;
        },
        error => {
          console.error('Error al obtener el estado del vendedor', error);
        }
      );
    } 

  getUserDetails(token, id): void {
    this.disabledPermissionLR = true;
    this.disabledPermissionBuybacks = true;
    this._managePermissionsService.getUser(token, id).subscribe({
      next: (response) => {
        // console.log('response', response);
        // console.log('response.data.permissions', response.data.permissions);
        this.userDetails = response;
        this.permissionsLiveReporting = this.userDetails.data.permissionsLiveReporting === 1;
        this.permissionsBuybacks = this.userDetails.data.permissions.includes(162);

        this.disabledPermissionLR = false;
        this.disabledPermissionBuybacks = false;
      },
      error: (error) => {
        console.error("Error fetching user details:", error);
      },
    });
  }

  onToggleChange(event: any, type: string) {
    this.isLoading = true;
    this.disabledPermissionLR = true;
    this.disabledPermissionBuybacks = true;
    this.disabledVendorStatus = true;
    const value = event.checked ? 1 : 0;

    this._managePermissionsService;

    const enableToggles = () => {
      this.disabledPermissionLR = false;
      this.disabledPermissionBuybacks = false;
      this.disabledVendorStatus = false;
    };

    
    if(type === 'live_reporting'){
      this.setPermissionLiveReporting(type, value);
      enableToggles();
    } else if(type === 'vendor_inventory'){
        this._poService.getChangeStateVendor(this.token, this.userData.userId, value, 'table').subscribe({

        next:  (r) => {

          const activate = event.checked ? true : false;
          this.permissionInventoryClient = activate; 
        
          if (activate) {
            this.permissionStatusColumn = true; 
          }

          this.permissionStatus = !!value; 
          if (!this.permissionStatus) {
            this.permissionStatusColumn = false; 
          }

            this.showToast('success', 'The permit was successfully applied', 6000);
            enableToggles();
            this.isLoading = false;
          },
         error:  (error) => {
          this.showToast('success', 'Oops! Something went wrong', 6000);
          enableToggles();
          this.isLoading = false;
          },
          complete: () => {
            enableToggles();
            this.isLoading = false;
          },
      });
    }else if(type == 'vendor_inventory_status_column'){
      this._poService.getChangeStateVendor(this.token, this.userData.userId, value, 'column').subscribe({
        next:  (r) => {
            this.showToast('success', 'The permit was successfully applied', 6000);
            enableToggles();
            this.isLoading = false;
          },
         error:  (error) => {
          this.showToast('success', 'Oops! Something went wrong', 6000);
          enableToggles();
          this.isLoading = false;
          },
          complete: () => {
            enableToggles();
            this.isLoading = false;
          },
      });
    }else if(type === 'buybacks'){
      this.setPermissionBuybacks(value);
      enableToggles();
    }
   
  }

  setPermissionBuybacks(value) {
    let body = {
      id: this.userDetails.data.id,
      data : JSON.parse(this.userDetails.data.permissions),
    };

    if(value === 1){
      body.data.push(162);
    }else{
      body.data = body.data.filter(item => item !== 162);
    }

    this._userService.update_user_permission(body).subscribe({
      next: (response) => {
        if (
          response.code === 400 &&
          response.msg === "Authorization not valid"
        ) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (response.status === "success") {
          this.showToast(
            "success",
            "The permit was successfully applied",
            6000
          );
        } else {
          this.showToast(
            "error",
            "Oops! Something went wrong",
            6000
          );
        }
      },
      error: (error) => {
        this.showToast("error", "Oops! Something went wrong", 6000);
      },
      complete: () => {
        this.getUserDetails(this.token, this.userData.userId);
        this.isLoading = false;
      },
    });
  }

  setPermissionLiveReporting(type, value) {
    this._managePermissionsService.setUserPermission(this.userData.userId, type, value, this.token)
    .subscribe({
      next: (response) => {
        // console.log("Response:", response);
        if(response.status === 'success'){
          this.showToast('success', 'The permit was successfully applied', 6000);
        }else{
          this.showToast('success', 'Oops! Something went wrong', 6000);
        }
        this.getUserDetails(this.token, this.userData.userId);
      },
      error: (error) => {
        console.error("Error:", error);
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  showToast(type, title, timer) {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      }
    });
 
    Toast.fire({
      icon: type,
      title: title
    });
  }

  
}
